import { useNavigate } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { patientService } from '../services/patientService'
import { PatientForm } from '../components/PatientForm'
import { PatientFormData } from '../types/patient'
import './PatientNew.css'

export function PatientNew() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createMutation = useMutation({
    mutationFn: (data: PatientFormData) => patientService.create(data),
    onSuccess: (patient) => {
      queryClient.invalidateQueries({ queryKey: ['patients'] })
      navigate(`/patients/${patient.id}`)
    },
  })

  const handleSubmit = async (data: PatientFormData) => {
    await createMutation.mutateAsync(data)
  }

  const handleCancel = () => {
    navigate('/patients')
  }

  return (
    <div className="patient-new">
      <h1>Register New Patient</h1>
      {createMutation.isError && (
        <div className="error-message">
          Failed to create patient. Please try again.
        </div>
      )}
      <PatientForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={createMutation.isPending}
      />
    </div>
  )
}

